import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  notification,
  Popconfirm,
} from "antd";
import { Space } from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import axios from "axios";

import { API_BASE_URL } from "shared/api/config";

const PackagePage = () => {
  const [data, setData] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  // const [form] = Form.useForm();
  const [editOpen, setEditOpen] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);
  const token = localStorage.getItem("token");
  const [createForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    p0: string,
    p1: string,
    type: "success" | "error" | "warning" | "info" = "error"
  ) => {
    api[type]({
      message: p0,
      description: p1,
    });
  };
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    fetchData();
  }, [token]);

  const fetchData = async () => {
    const res = await axios.get(`${API_BASE_URL}/package/get`);
    setData(res.data);
  };

  const handleCreate = async () => {
    const values = await createForm.validateFields();
    try {
      await axios.post(`${API_BASE_URL}/package`, values);

      message.success("Амжилттай нэмэгдлээ");
      setOpen(false);
      createForm.resetFields();
      fetchData();
    } catch (error: any) {
      if (error.errorFields) {
        return;
      }
      openNotification("Алдаа", "Орлого авахад алдаа гарлаа");
    }
  };

  const handleDelete = async (id: string) => {
    await axios.delete(`${API_BASE_URL}/package/delete${id}`);
    message.success("Устгагдлаа");
    fetchData();
  };
  const handleEditClick = (record: any) => {
    setEditingId(record._id);

    editForm.setFieldsValue({
      label: record.label,
      options: record.options,
    });

    setEditOpen(true);
  };

  const handleUpdate = async () => {
    const values = await editForm.validateFields();

    await axios.put(`${API_BASE_URL}/package/${editingId}`, values);

    message.success("Амжилттай засагдлаа");
    setEditOpen(false);
    setEditingId(null);
    editForm.resetFields();
    fetchData();
  };

  const doDelete = async (id: string) => {
    try {
      await handleDelete(id);
      message.success("Устгагдлаа");
      // await load();
    } catch (e: any) {
      message.error(e?.message || "Delete error");
    }
  };

  const columns = [
    { title: "Group", dataIndex: "label" },
    {
      title: "Options",
      render: (record: any) =>
        record.options.map((o: any) => (
          <div key={o.value}>
            {o.label} - {o.price}₮
          </div>
        )),
    },
    {
      title: "Action",
      render: (record: any) => (
        <Popconfirm
          title="Устгах уу?"
          okText="Тийм"
          cancelText="Үгүй"
          onConfirm={() => doDelete(record._id)}
        >
          <Button hidden danger>Delete</Button>
        </Popconfirm>
      ),
    },
    {
      title: "Action",
      render: (record: any) => (
        <Button onClick={() => handleEditClick(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div>
      {contextHolder}
      <Button style={{margin:"20px"}} type="primary" onClick={() => setOpen(true)}>
        + Package нэмэх
      </Button>

      <Table dataSource={data} columns={columns} rowKey="_id" />

      <Modal
        width={800}
        title="Package нэмэх"
        open={open}
        onCancel={() => {
          setOpen(false);
          createForm.resetFields(); // 🔥 clear
        }}
        onOk={() => createForm.submit()}
      >
        <Form form={createForm} layout="vertical" onFinish={handleCreate}>
          {/* Group name */}
          <Form.Item
            name="label"
            label="Group нэр"
            rules={[{ required: true, message: "Group нэр оруулна уу" }]}
          >
            <Input />
          </Form.Item>

          {/* OPTIONS LIST */}
          <Form.List name="options">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      gap: 8,
                      marginBottom: 8,
                      alignItems: "center",
                    }}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "label"]}
                      rules={[
                        { required: true, message: "Багцын нэр оруулна уу" },
                      ]}
                      style={{ flex: 2 }}
                    >
                      <Input placeholder="Жишээ нь: Портрайт багц" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "value"]}
                      rules={[{ required: true, message: "Value оруулна уу" }]}
                      style={{ flex: 1 }}
                    >
                      <Input placeholder="Тухайлсан багц" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "price"]}
                      rules={[{ required: true, message: "Үнэ оруулна уу" }]}
                      style={{ flex: 1 }}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Price"
                      />
                    </Form.Item>
                    <Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Form.Item>
                  </div>
                ))}

                <Button type="dashed" onClick={() => add()} block>
                  + Option нэмэх
                </Button>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
      <Modal
        width={800}
        title="Package засах"
        open={editOpen}
        onCancel={() => {
          setEditOpen(false);
          editForm.resetFields(); // 🔥 very important
          setEditingId(null);
        }}
        onOk={handleUpdate}
        destroyOnClose
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }} // 🔥
      >
        <Form form={editForm} layout="vertical">
          <Form.Item
            name="label"
            label="Group нэр"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.List name="options">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{ display: "flex", justifyContent: "space-between" }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "label"]}
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Label" width={300} />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "value"]}
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Value" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "price"]}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Price"
                      />
                    </Form.Item>

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}

                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                  block
                >
                  Add option
                </Button>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </div>
  );
};

export default PackagePage;
